module.exports = new __parcel__URL__("dinosaur.e5c6efb5.svg").toString();